/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientApp {
    angular.module("meevo.plugins.clientApp", []);
}